import React from 'react';

import { useToggle } from 'react-use';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';

import { InfoBox, InfoBoxProps } from '@infoods/lifebase-ui';

import classes from './CollapsibleInfoBox.module.scss';

type CollapsableInfoBoxProps = Omit<InfoBoxProps, 'hideConfig'> & {
  defaultOpen?: boolean;
};

const CollapsableInfoBox = ({ defaultOpen, ...props }: CollapsableInfoBoxProps) => {
  const [isOpen, toggleOpen] = useToggle(!!defaultOpen);

  const Icon = isOpen ? RemoveRoundedIcon : AddRoundedIcon;

  return (
    <InfoBox
      {...props}
      hideConfig={{ show: isOpen }}
      adornment={
        <>
          <Icon />
          <button className={classes.button} type="button" onClick={toggleOpen}></button>
        </>
      }
    />
  );
};

export { CollapsableInfoBox };
